// extracted by mini-css-extract-plugin
export var closeButton = "_lw-1";
export var closeX = "_lw-3";
export var container = "_lw-0";
export var image = "_lw-2";